import { IEnvironment } from '../app/core';

export const environment: IEnvironment = {
  production: true,
  version: '2.0.1',
  debugInfoEnabled: false,
  ngpBackendURL: 'https://testngpserver.entreda.com',
  bffURL: 'https://api.dev.cyber.entreda.com/bff',
  portalURL: 'https://[PORTAL].entreda.com',
  userMicroServiceURL_LPL: 'https://uob-qa.entreda.com',
  userMicroServiceURL_SECURE: 'https://sec-qa-uob.entreda.com',
  analyticsDataAPIServerURL: 'https://staging-ag-qa.entreda.com:8082/',
  chartAlertServerURL: 'https://testalertserver.entreda.com',
  showLoginSection: 'true',
  sessionIdleTime: '480',
  sessionTimeoutTime: '120',
  chartPortal: '[PORTAL]',
  defaultPortal: 'ag-dev',
  bffURLVersion: 'v2',
  authMiddlewareURL: 'https://api.dev.cyber.entreda.com/auth'
};
